import { ItemPicklist } from './item-picklist.model';
import { Component, Input, Output, EventEmitter, OnChanges, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'picklist',
  templateUrl: './picklist.component.html',
  styleUrls: ['./picklist.component.scss']
})
export class PicklistComponent implements OnChanges, OnInit {

  @Input() itens:Array<ItemPicklist> = [];
  @Input() rotuloBotaoAdicionarTodos = "Adicionar todos";
  @Input() rotuloBotaoRemoverTodos = "Remover todos";
  @Input() rotuloNaoAdicionados = "Itens não selecionados";
  @Input() rotuloAdicionados = "Itens selecionados";

  @Output() salvar = new EventEmitter();
  @Output() cancelar = new EventEmitter();

  @ViewChild('selectItensForaSelecao') selectItensForaSelecao;
  @ViewChild('selectItensSelecao') selectItensSelecao;

  itensForaSelecao:Array<any> = [];
  itensSelecao:Array<any> = [];

  itensASelecionar: any = [];
  itensADesselecionar: any = [];

  public selectsCarregados: boolean;

  ngOnInit() {
    this.selectsCarregados = false;
  }

  ngOnChanges() {
    if(!this.selectsCarregados && this.itens && this.itens.length>0) {
      for(let item of this.itens) {
        if (item.selecionado) {
          this.itensSelecao.push({id:item.id,value:item.valor});
        } else {
          this.itensForaSelecao.push({id:item.id,value:item.valor});
        }
      }
      this.selectsCarregados = true;
    }
  }

  onSalvar() {
    this.salvar.emit(this.itensSelecao);
  }

  onCancelar() {
    this.cancelar.emit();
  }

  onBlurItensSelecao(evento) {
    if(evento.relatedTarget==null || evento.relatedTarget.id!=="remover") {
      this.selectItensSelecao.nativeElement.options.selectedIndex=-1;
    }
  }

  onBlurItensForaSelecao(evento) {
    if(evento.relatedTarget==null || evento.relatedTarget.id!=="selecionar") {
      this.selectItensForaSelecao.nativeElement.options.selectedIndex=-1;
    }
  }

  selecionar() {
    for(let opcao of this.selectItensForaSelecao.nativeElement.options) {
      if(opcao.selected == true) {

        let itens = [];
        for(let item of this.itensForaSelecao) {
          itens.push(item.id);
        }

        let index: number = itens.indexOf(opcao.id);
        if (index !== -1) {
            this.itensForaSelecao.splice(index, 1);
        }

        let opcaoSelecionada:any = {};
        opcaoSelecionada.id = opcao.id;
        opcaoSelecionada.value = opcao.value;

        this.itensSelecao.push(opcaoSelecionada);
      }
    }
  }

  selecionarTodos() {
    this.itensForaSelecao = [];
    for(let opcao of this.selectItensForaSelecao.nativeElement.options) {

      let opcaoSelecionada:any = {};
      opcaoSelecionada.id = opcao.id;
      opcaoSelecionada.value = opcao.value;

      this.itensSelecao.push(opcaoSelecionada);
    }
  }

  remover() {
    for(let opcao of this.selectItensSelecao.nativeElement.options) {
      if(opcao.selected == true) {

        let itens = [];
        for(let item of this.itensSelecao) {
          itens.push(item.id);
        }

        let index: number = itens.indexOf(opcao.id);
        if (index !== -1) {
            this.itensSelecao.splice(index, 1);
        }

        let opcaoSelecionada:any = {};
        opcaoSelecionada.id = opcao.id;
        opcaoSelecionada.value = opcao.value;

        this.itensForaSelecao.push(opcaoSelecionada);
      }
    }
  }

  removerTodos() {
    this.itensSelecao = [];
    for(let opcao of this.selectItensSelecao.nativeElement.options) {
      let opcaoSelecionada:any = {};
      opcaoSelecionada.id = opcao.id;
      opcaoSelecionada.value = opcao.value;

      this.itensForaSelecao.push(opcaoSelecionada);
    }
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/picklist/picklist.component.ts